import { downloadExcelFile } from "../../assets/commonFunctions/CommonFunction";
import { app } from "../serviceLMS";
import { GET_COURSE_KPI_REPORT,Download_ALL_COURSE_REPORT , GET_SINGLE_COURSE_REPORT,GET_COURSE_CONTENT,DOWNLOAD_SINGLE_KPI_REPORT, Filter_Options_KPI_REPORT} from "../URLs";

export const fetchAdminCourses = async ({ page, pageSize, search, active, sortDir="desc" }) => {
  try {
    const endpoint = `course/api/client-api/course/paged`;

    const response = await app.get(endpoint, { params: { page: page, size: pageSize, search, active, sortDir } });
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const getCourseKpiReport = async (page, pageSize, isCourseActive, searchText) => {
  try {
    const response = await app.get(GET_COURSE_KPI_REPORT, {
      params: { page: page, size: pageSize, isCourseActive, search:searchText },
    });
    
    return response.data.data;
  } catch (error) {
    return { success: false, message: error.message }
  }
};



export async function fetchCourseContentByCourseId(courseId, queryParams = {}) {
  try {
    const response = await app.get(`${GET_COURSE_CONTENT}/${courseId}/paged`, {
      params: {
        page: queryParams.page,
        size: queryParams.size,
        search: queryParams.search, 
        active: queryParams.active || "false",
        sortBy: queryParams.sortBy || "createdAt",
        sortDir: queryParams.sortDir || "desc",
      },
    });
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data };
      
    } else {
      return { success: false, data: "Failed to fetch course content." };
    }
  } catch (error) {
    return { success: false, data: error?.response?.data?.message || "Error fetching groups." };
  }
}


export async function fetchSingleContentReport(courseId, contentId,params) {
  try {
    const response = await app.get(`user/api/client-api/report/course/${courseId}/content/${contentId}`, {params});
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch data ",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error fetching report",
    };
  }
}

export const downloadSingleContentReport = async(courseId, contentId, params)=> {
   try {
    const response = await app.get(
      `user/api/client-api/report/course/${courseId}/content/${contentId}/download`,
      {
        params,
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    link.setAttribute("download", "group_kpi_report.xlsx");

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Download failed",
    };
  }
}


export async function fetchContentReport(courseId, params) {
  try {
    const response = await app.get(`user/api/client-api/report/course/${courseId}/contents`, {params});
    if (response.status === 200 || response.status === 201) {
      return { success: true, data: response.data.data };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to fetch data ",
      };
    }
  } catch (error) {
    return {
      success: false,
      message: error?.response?.data?.message || "Error fetching report",
    };
  }
}

export const downloadContentReport = async(courseId, params)=> {
   try {
    const response = await app.get(
      `/user/api/client-api/report/course/${courseId}/contents/download`,
      {
        params,
        responseType: "blob",
      }
    );

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;

    link.setAttribute("download", "group_kpi_report.xlsx");

    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return { success: true };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message || "Download failed",
    };
  }
}
//Single course KPI Page 
export const getSingleCourseReport = async (courseId , params={}) => {
  try {
     const response = await app.get(`${GET_SINGLE_COURSE_REPORT}${courseId}`,{
       params: {
        page:       params.page       ?? 0,
        size:       params.size       ?? 10,
        sortDir:    params.sortDir    || "DESC",
        search:     params.search     || undefined,
        filterType: params.filterType || undefined,
        subType:    params.subType    || undefined,
        status:     params.status     || undefined,
        groupId:    params.groupId    || undefined,  
        userId:     params.userId     || undefined, 
        bundleId:   params.bundleId   || undefined,  
      },
     });
    return response.data.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};

export const downloadSingleKpiReport = async(courseId)=>{
   try {
    const response = await app.get(`${DOWNLOAD_SINGLE_KPI_REPORT}${courseId}/download`, {
      responseType: "blob",

    });

    downloadExcelFile(response?.data ,`course_report_${courseId}.xlsx` );
    return { success: true, data: " Course KPI Report downloaded successfully." }

  } catch (error) {
    console.error("Error downloading user KPI report:", error);
    throw error;
  }
}

export const filterOptions = async(courseId)=>{
  try {
    const response = await app.get(`${Filter_Options_KPI_REPORT}${courseId}/filter-options`);
    return response.data.data;
  } catch (error) {
    throw new Error(error?.response?.data?.message || "Failed to fetch filter options");
  }

}


export const downloadCourseKpiReport = async (isCourseActive, searchText) => {
  try {
    const params = { isCourseActive , search:searchText,sortDir:"DESC"};
    const response = await app.get(
      `${Download_ALL_COURSE_REPORT}`,
      {
        params,
        responseType: "blob",
      }
    );

    downloadExcelFile(response.data, "course_kpi_report");

  } catch (error) {
    throw new Error(error?.response?.data?.message || "Download failed");
  }
};